import { Configuration } from 'api/base/configuration'

export const configuration: Configuration = {
  basePath: import.meta.env.VITE_APPLICATION_ENDPOINT
}
